enum EListOfPlans {
    Platinum = "Platinum",
    Premium = "Premium",
    Gold = "Gold",
    Free = "Free",
    Trial = "Trial",
    Trip_Pass = "Trip Pass",
  }
  
  export default EListOfPlans;
  